import { render } from "./CustomColumnTemplate.vue?vue&type=template&id=269620e6"
import script from "./CustomColumnTemplate.vue?vue&type=script&lang=ts"
export * from "./CustomColumnTemplate.vue?vue&type=script&lang=ts"
script.render = render

export default script